define([
    'edge/platform/branding/BrandingData',
], (BrandingData) => {
    return ['StateUtils', (StateUtils) => {
        let motorcycleMode;
        /*
        * This property is used for the visualization on the gui (checkbox)
        * And not the property from the dto (draftdata.dataProcessingConfirmed)
        * */
        let dataProcessingConfirmed;

        const service = {
            setDataProcessingConfirmed: (value) => dataProcessingConfirmed = value,
            getDataProcessingConfirmed: () => Boolean(dataProcessingConfirmed),
            getAdvisorNumber: () => getDraftDataProperty('directAdvisorNumber'),
            getSalespoint: () => getDraftDataProperty('salespointCode'),
            getBrandCode: () => getDraftDataProperty('brandCode'),
            getProductCode: () => getProperty('productCode'),
            getSubproductCode: () => getProperty('subproductCode'),
            getSubproductInputParam: () => getProperty('subproductInputParam'),
            isProductCode: productCode => productCode.toLowerCase() === getProperty('productCode'),
            isTCSProduct: () => service.isProductCode('TCSCombiMotorfahrzeug'),
            isDirectProduct: () => service.isProductCode('BaloiseDirectMotorfahrzeug'),
            isLeasePlan: () => service.getSubproductCode() === 'leaseplan' || service.getSubproductInputParam() === 'leaseplan',
            isPartnerDirectProduct: () => service.isProductCode('PartnerDirectMotorfahrzeug'),
            isPartnerLeasingProduct: () => service.isProductCode('PartnerLeasingMotorfahrzeug'),
            isPartnerProduct: () => service.isPartnerDirectProduct() || service.isPartnerLeasingProduct(),
            getChannel: () => BrandingData.BRANDING || 'baloise',
            isTCSChannel: () => service.getChannel() === 'tcs',
            setMotorcycleMode(value) {
                motorcycleMode = value;
            },
            isMotorcycleMode: () => motorcycleMode,
            isEmployeeMode: () => getDraftDataProperty('employeeMode'),
        };

        function getDraftDataProperty(property) {
            const {model} = StateUtils.dataForState('baseQnbWizard');
            return model && model.value && model.value.draftData && model.value.draftData[property];
        }

        function getProperty(propertyName) {
            const property = getDraftDataProperty(propertyName);

            if (property) {
                return property.toLowerCase();
            }
        }

        return service;
    }];
});



// WEBPACK FOOTER //
// ../common/js/src/edge/platform/basler/services/ContextService.js